<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.keyword" placeholder="请输入楼层名称" style="width: 220px;" class="filter-item" clearable/>
      <!-- <el-select v-model="listQuery.building_id" class="filter-item" placeholder="楼栋" style="width: 140px" clearable>
        <el-option v-for="item in buildings" :key="item.id" :label="item.building_name" :value="item.id">
        </el-option>
      </el-select> -->
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="dialogVisible = true">添加</el-button>
    </div>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column align="center" label="ID" width="60">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.building.school.school_name }}
        </template>
      </el-table-column>
      <el-table-column label="楼栋名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.building.building_name }}
        </template>
      </el-table-column>
      <el-table-column label="楼层名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.floor_name }}
        </template>
      </el-table-column>
      <el-table-column label="外卖派送员" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sendman ? scope.row.sendman.name : '' }}
        </template>
      </el-table-column>
      <el-table-column label="舍购派送员" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.shegou_sendman ? scope.row.shegou_sendman.name : '' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="handleSendman(scope.row)">派送员</el-button>
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-position="left" label-width="70px">
        <el-form-item label="楼层名称" prop="name">
          <el-input v-model="form.floor_name" placeholder="请输入楼层名称" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="sendmanDialogVisible" :close-on-click-modal="false">
      <el-form ref="sendmanForm" :model="sendmanForm" label-position="left" label-width="100px">
        <el-form-item label="外卖派送员">
          <el-select v-model="sendmanForm.sendman_id" filterable class="filter-item" placeholder="外卖派送员" style="width: 140px" clearable>
            <el-option v-for="item in sendmans" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="舍购派送员">
          <el-select v-model="sendmanForm.shegou_sendman_id" filterable class="filter-item" placeholder="舍购派送员" style="width: 140px" clearable>
            <el-option v-for="item in sendmans" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendmanDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveSendmanData" :loading="sendmanBtnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keyword: "",
        school_id: "",
        building_id: ""
      },
      dialogVisible: false,
      btnLoading: false,
      form: {
        id: "",
        school_id: "",
        building_id: "",
        floor_name: ""
      },
      buildings: [],
      sendmanDialogVisible: false,
      sendmanBtnLoading: false,
      sendmanForm: {
        id: "",
        sendman_id: "",
        shegou_sendman_id: ""
      },
      sendmans: [],
    };
  },
  created() {
    if (this.$route.query.building_id) {
      this.listQuery.building_id = parseInt(this.$route.query.building_id);
    }
    this.getList();
    this.getBuildingList();
    this.getSendmanList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["schools", "school_id"])
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.getList();
      this.$router.push("/building/index");
    },
    sendmanDialogVisible(newVal, oldVal) {
      if (newVal === false) {
        this.sendmanForm = {
          id: "",
          sendman_id: "",
          shegou_sendman_id: ""
        };
      }
    },
    dialogVisible(newVal, oldVal) {
      // 编辑框一异隐藏，马上清除旧数据
      if (newVal === false) {
        this.form = {
          id: "",
          school_id: "",
          building_id: "",
          floor_name: ""
        };
      }
    }
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/floor/list",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    getBuildingList() {
      this.listQuery.school_id = this.school_id;
      request({
        url: "/api/backend/building/list",
        method: "get",
        params: {
          page: 1,
          limit: 100000
        }
      }).then(response => {
        this.buildings = response.data.data;
      });
    },
    getSendmanList() {
      request({
        url: "/api/backend/sendman/list",
        method: "get",
        params: {
          page: 1,
          limit: 100000,
          school_id: this.school_id,
        }
      }).then(response => {
        this.sendmans = response.data.data;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleEdit(item) {
      this.form = {
        id: item.id,
        school_id: item.school_id,
        building_id: item.building_id,
        floor_name: item.floor_name
      };
      this.dialogVisible = true;
    },
    handleSendman(item) {
      this.sendmanForm = {
        id: item.id,
        sendman_id: item.sendman_id || '',
        shegou_sendman_id: item.shegou_sendman_id || ''
      };
      this.sendmanDialogVisible = true;
    },
    handleDel(item) {
      this.$confirm("确定要删除该楼层吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/floor/del",
          method: "get",
          params: {
            id: item.id
          }
        }).then(() => {
          // 删除最后一条数据时无数据问题
          this.list.length <= 1 ? this.listQuery.page-- : false;
          this.getList();
          this.$message({
            type: "success",
            message: "操作成功!"
          });
        });
      });
    },
    saveData() {
      if (!this.school_id) {
        this.$message({
          type: "warning",
          message: "请选择学校"
        });
        return;
      } else {
        this.form.school_id = this.school_id;
      }
      if (!this.listQuery.building_id) {
        this.$message({
          type: "warning",
          message: "请先选择楼栋"
        });
        return;
      }
      this.form.building_id = this.listQuery.building_id;
      if (!this.form.floor_name) {
        this.$message({
          type: "warning",
          message: "请输入楼层名称"
        });
        return;
      }
      this.btnLoading = true;
      request({
        url: "/api/backend/floor/save",
        method: "post",
        data: this.form
      }).then(() => {
        this.btnLoading = false;
        this.dialogVisible = false;
        this.getList();
        this.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    saveSendmanData() {
      this.sendmanBtnLoading = true;
      request({
        url: "/api/backend/floor/sendman",
        method: "post",
        data: this.sendmanForm
      }).then(() => {
        this.sendmanBtnLoading = false;
        this.sendmanDialogVisible = false;
        this.getList();
        this.$message({
          type: "success",
          message: "操作成功!"
        });
      }).catch(()=>{
        this.sendmanBtnLoading = false;
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.floor-container {
  display: inline-block;
  width: 160px;
  height: 160px;
  margin-right: 25px;
  margin-bottom: 25px;
}
</style>
